import { render, staticRenderFns } from "./NicheDistrict.vue?vue&type=template&id=1fa187dd&scoped=true"
import script from "./NicheDistrict.vue?vue&type=script&lang=js"
export * from "./NicheDistrict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa187dd",
  null
  
)

export default component.exports